import * as React from 'react';
import {
  Platform,
  StyleSheet,
  TouchableOpacity,
  Image,
  View,
} from 'react-native';
import colors from '../constants/colors';

import { FontAwesome, FontAwesome5 } from '@expo/vector-icons';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth/lib/types";
import { InAppBrowser } from 'react-native-inappbrowser-reborn'

import { AppContext, IContext } from '../store/app-provider';
//@ts-ignore
import { Authenticator } from 'aws-amplify-react-native';
import style from "../constants/style";
import {
  buttonColor,
  deepSquidInk,
  disabledButtonColor, linkUnderlayColor,
  textInputBorderColor, textInputColor
} from "aws-amplify-react-native/src/AmplifyTheme";

interface Props {

}

interface State {

}

class LoginScreen extends React.Component<Props, State> {
  fbIcon = 'data:image/png;base64,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'
  googleIcon = 'data:image/png;base64,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'
  appleIcon = 'data:image/png;base64,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'
  loadedMyMemes: boolean = false;
  static contextType = AppContext;
  declare context: IContext
  isFetchingPosts: boolean = false;

  constructor(props: any) {
    super(props);
  }

  setURLOpener() {
    if (Platform.OS === 'web') {
      return;
    }
    const opener = (url: string) => {
      //Browser.open({ url })
      InAppBrowser.open(url)
    };
    const config: any = Auth.configure(null);
    config.oauth.urlOpener = opener;
    Auth.configure(config);
  }

  async componentDidMount() {

  }

  componentDidUpdate(prevPops: any) {

  }

  async signOut() {
    /* this.context.setUser(null);
     this.context.setScreen('Home', true);
     this.setURLOpener();
     await Auth.signOut({});*/
  }

  loginWithFacebook() {
    this.setURLOpener();
    Auth.federatedSignIn({ provider: 'Facebook' });
  }

  loginWithGoogle() {
    this.setURLOpener();
    Auth.federatedSignIn({ provider: 'Google' });
  }

  loginWithApple() {
    this.setURLOpener();
    Auth.federatedSignIn({ provider: 'SignInWithApple' });
  }

  render() {

    return (
      !this.context.state.user ?
        <View style={style.page}><View style={style.container}>

          <Authenticator theme={authStyles} signUpConfig={{
            header: '',
            hideAllDefaults: true,
            defaultCountryCode: '1',
            signUpFields: [
              {
                label: 'Email Address',
                key: 'username',
                required: true,
                displayOrder: 1,
                type: 'string'
              },
              {
                label: 'First Name',
                key: 'given_name',
                required: true,
                displayOrder: 2,
                type: 'string'
              },
              {
                label: 'Last Name',
                key: 'family_name',
                required: true,
                displayOrder: 3,
                type: 'string'
              },
              {
                label: 'Password',
                key: 'password',
                required: true,
                displayOrder: 4,
                type: 'password'
              }
            ]
          }} usernameAttributes="email">

          </Authenticator>


          <View style={[style.row, { width: '100%', justifyContent: 'center', marginBottom: 20, marginTop: 10 }]}>
            <TouchableOpacity onPress={this.loginWithFacebook.bind(this)}>
              <View style={{ display: 'flex', width: 48, height: 48, justifyContent: 'center', alignItems: 'center' }}>
                <Image style={[{
                  height: 48,
                  width: 48
                }]} source={{ uri: this.fbIcon }}></Image>
                {/* <Text style={[styles.mainTitle, { fontSize: 10, color: colors.secondaryColor, opacity: 1 }]}>[{this.props.t('translated clips')}]</Text> */}
              </View>
            </TouchableOpacity>
            <TouchableOpacity onPress={this.loginWithGoogle.bind(this)}>
              <View style={{
                display: 'flex',
                width: 48,
                height: 48,
                justifyContent: 'center',
                marginLeft: 15,
                alignItems: 'center'
              }}>
                <Image style={[{
                  height: 48,
                  width: 48
                }]} source={{ uri: this.googleIcon }}></Image>
                {/* <Text style={[styles.mainTitle, { fontSize: 10, color: colors.secondaryColor, opacity: 1 }]}>[{this.props.t('translated clips')}]</Text> */}
              </View>
            </TouchableOpacity>
            <TouchableOpacity onPress={this.loginWithApple.bind(this)}>
              <View style={{
                display: 'flex',
                width: 48,
                height: 48,
                justifyContent: 'center',
                marginLeft: 15,
                alignItems: 'center'
              }}>
                <Image style={[{
                  height: 48,
                  width: 48
                }]} source={{ uri: this.appleIcon }}></Image>
                {/* <Text style={[styles.mainTitle, { fontSize: 10, color: colors.secondaryColor, opacity: 1 }]}>[{this.props.t('translated clips')}]</Text> */}
              </View>
            </TouchableOpacity>


          </View>

        </View></View> : null)

  };

}

export default LoginScreen

const styles = StyleSheet.create({
  container: {

    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: 0,
    width: 400,
    flex: 1,
    backgroundColor: 'transparent',
  }
});
const authStyles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: 20,
    width: 400,
    flex: 1,
    backgroundColor: 'transparent',
  },
  section: {
    flex: 1,
    width: '100%',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
  },
  sectionScroll: {
    flex: 1,
    width: '100%',
    paddingHorizontal: 20,
  },
  sectionHeader: {
    width: '100%',
    marginBottom: 32,
    paddingTop: 20,
  },
  sectionHeaderText: {
    fontSize: 18,
    marginBottom: 8,
    fontFamily: 'Jost',
    color: colors.textColor,
  },
  sectionFooter: {
    width: '100%',
    padding: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 15,
    marginBottom: 20,
  },
  sectionFooterLink: {
    fontSize: 14,
    color: colors.textColor,
    fontFamily: 'Jost',
    alignItems: 'baseline',
    textAlign: 'center',
  },
  sectionFooterLinkDisabled: {
    fontSize: 14,
    color: colors.disabledButtonColor,
    alignItems: 'baseline',
    textAlign: 'center',
  },
  navBar: {
    marginTop: 35,
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  navButton: {
    marginLeft: 12,
    borderRadius: 4,
  },
  cell: {
    flex: 1,
    width: '50%',
  },
  errorRow: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorRowIcon: {
    height: 25,
    width: 25,
  },
  errorRowText: {
    marginLeft: 10,
  },
  photo: {
    width: '100%',
  },
  album: {
    width: '100%',
  },
  button: {
    shadowColor: colors.primaryColor,
    shadowOffset: { width: 3, height: 9 },
    shadowRadius: 11,
    elevation: 11,
    shadowOpacity: 0.4,
    borderRadius: colors.borderRadius,
    borderWidth: 0,
    borderColor: colors.primaryColor,
    backgroundColor: colors.primaryColor,
    alignItems: 'center',
    padding: 14,
  },
  buttonDisabled: {
    borderRadius: colors.borderRadius,
    borderWidth: 0,
    borderColor: colors.primaryColor,
    padding: 14,
    backgroundColor: colors.disabledButtonColor,
    alignItems: 'center',
  },
  buttonText: {
    color: colors.iconColorWhite,
    fontWeight: 'normal',
    fontFamily: 'Jost',
    fontSize: 16

  },
  formField: {
    marginBottom: 22,
  },
  input: {
    backgroundColor: colors.grey,
    padding: 12,
    fontSize: 16,
    fontFamily: 'Jost',
    borderRadius: colors.borderRadius,
    color: colors.textColor,
    borderWidth: 0,
  },
  inputLabel: {
    fontSize: 16,
    marginBottom: 8,
    fontWeight: 'normal',
    fontFamily: 'Jost',
    color: colors.textColor,
  },
  linkUnderlay: {
    fontFamily: 'Jost',
    color: colors.textColor,
  },
  phoneContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  phoneInput: {
    flex: 2,
    padding: 16,
    borderWidth: 1,
    borderRadius: 3,
    color: colors.textColor,
  },
  picker: {
    flex: 1,
    height: 44,
    // ensure that longer text values render without truncation
    // as the selected value of the Picker on Android
    minWidth: Platform.OS === 'android' ? 16 : 0,
  },
  pickerItem: {
    height: 44,
  },
  signedOutMessage: {
    fontFamily: 'Jost',
    textAlign: 'center',
    padding: 20,
  },
});
